import React from "react";
import { Card } from "antd";
import { ResponsiveFunnel } from "@nivo/funnel";

const Funnel = ({ data, title, scheme="nivo" }) => (
  <Card
    title={title}
    hoverable
    className="analytics-card"
    style={{ width: "100%" }}
  >
    {data && data.length > 0 ? (
      <ResponsiveFunnel
        data={data}
        margin={{ top: 20, right: 20, bottom: 20, left: 20 }}
        colors={{ scheme: scheme }}
        borderWidth={20}
        labelColor={{ from: "color", modifiers: [["darker", 3]] }}
        beforeSeparatorLength={100}
        beforeSeparatorOffset={20}
        afterSeparatorLength={100}
        afterSeparatorOffset={20}
        currentPartSizeExtension={10}
        currentBorderWidth={40}
        motionConfig="wobbly"
      />
    ) : (
      <div className="no-data-avaliable">No Data Avaliable</div>
    )}
  </Card>
);

export default Funnel;
